import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { trackByName } from '@shared/common/track-by.util';
import { GetAllProjectDto, ProjectServiceProxy, ProjectType, ProjectType5 } from '@shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: "app-project-filter",
    templateUrl: "./project-filter.component.html",
    styleUrls: ["./project-filter.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ProjectFilterComponent implements OnInit {
    readonly trackByName = trackByName;
    items: any[];
    @Output() change = new EventEmitter<GetAllProjectDto[]>();

    // Input properties
    @Input() multiselect: boolean;
    @Input() closeOnSelect: boolean;
    @Input() placeholder: string;
    @Input() disabled: boolean;
    @Input() projectType: ProjectType;
    @Input() loadOnlyMyProjects: boolean;
    @Input() inputProjectitems: GetAllProjectDto[];
    @Input() isSlice = true;
    @Input() maximumProjectNameLengthTooltipNotMultiselect = 15;
    @Input() maximumProjectNameLengthTooltipMultiselect   = 15;

    // Non input properties
    bindLabel: string = "name";
    selectedItems: any;
    loading: boolean = false;
    showselectall: boolean = true;
    showdeselectall: boolean = false;
    projectToSet: number;
    selectedItemsLength: number;

    constructor(private _projectServiceProxy: ProjectServiceProxy, private cdRef: ChangeDetectorRef) {}

    ngOnInit() {
        this.selectedItems = this.inputProjectitems;
        this.projectType;
        this.getAllProjectsDropdown();

    }
    getAllProjectsDropdown(){
        this._projectServiceProxy
            .dropdownProjectList(abp.session.userId, abp.session.tenantId, this.loadOnlyMyProjects === true ? true : false)
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .subscribe((res) => {
                this.items = [];
                res.forEach((x) => {
                    if (!x.projectImage) {
                        x.projectImage = "assets/common/images/new-dashboard/default-project-bag.svg";
                    }
                    this.items.push(x);
                });

                if (this.projectToSet && !this.selectedItems) {
                    this.selectedItems = this.items.filter((r) => r.id === this.projectToSet)[0];
                    this.cdRef.detectChanges();
                    this.emitSelection();
                }
            });
    }
    ngOnChanges() {
        if (this.projectType === 1) {
            this.getActiveProject();
        }
        if  (this.projectType === 2) {
            this.getArchiveProjects();
        }
        if (this.projectType ===3) {
            this.getDeletedProjects();
        }
    }

    getActiveProject() {
        //this.loading = true;
        //this._projectServiceProxy
        //    .getProjectsByUserIds(undefined, ProjectType.AllProjects,undefined, undefined, undefined)
        //    .pipe(
        //        finalize(() => {
        //            this.loading = false;
        //        })
        //    )
        //    .subscribe((res) => {
        //        this.items = [];
        //        res.forEach((x) => {
        //            if (!x.projectImage) {
        //                x.projectImage = "assets/common/images/new-dashboard/default-project-bag.svg";
        //            }
        //            this.items.push(x);
        //            //this.masterListProjectsData = this.projectsData;
        //        });
        //    });
    }

    getArchiveProjects() {
        this.loading = true;
        this._projectServiceProxy
            .getProjectsByUserIds(undefined, ProjectType5.ArchivedProjects,undefined, undefined, undefined)
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .subscribe((res) => {
                this.items = [];
                res.forEach((x) => {
                    if (!x.projectImage) {
                        x.projectImage = "assets/common/images/new-dashboard/default-project-bag.svg";
                    }
                    this.items.push(x);
                });
            });
    }

    getDeletedProjects() {
        this.loading = true;
        this._projectServiceProxy
            .getProjectsByUserIds(undefined, ProjectType5.DeletedProjects,undefined, undefined, undefined)
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .subscribe((res) => {
                this.items = [];
                res.forEach((x) => {
                    if (!x.projectImage) {
                        x.projectImage = "assets/common/images/new-dashboard/default-project-bag.svg";
                    }
                    this.items.push(x);
                });
            });
    }

    emitSelection() {
        if (!this.selectedItems)
            return;
        if (this.selectedItems.length != this.items.length) {
            this.showselectall = true;
            this.showdeselectall = false;
        } else {
            this.showselectall = false;
            this.showdeselectall = true;
        }
        this.selectedItemsLength = this.selectedItems.length;
        this.change.emit(this.selectedItems);
    }

    showTooltipForString(str: string, maxLength: number) {
        if (str && str.length <= maxLength) return true;
        return false;
    }

    selectAll() {
        this.selectedItems = this.items;
        this.showselectall = false;
        this.showdeselectall = true;
        this.change.emit(this.selectedItems);
    }

    unselectAll() {
        this.selectedItems = [];
        this.showselectall = true;
        this.showdeselectall = false;
        this.change.emit(this.selectedItems);
    }

    rearrangeItems() {
    }

    setProjectId(projectId: number) {
        if (projectId) this.projectToSet = projectId;
        if (this.items && !this.selectedItems) {
            this.selectedItems = this.items.filter((r) => r.id === this.projectToSet)[0];
            this.cdRef.detectChanges();
            this.emitSelection();
        }
    }

    clearSelection() {

        this.selectedItems = undefined;
        this.change.emit(this.selectedItems);
    }

    checkUncheck(item: any | undefined) {
        if (item && item.hasOwnProperty('selected')) {
          item.selected = !item.selected;
        }
      }

}
